import { UniformFilterObject, FilterCategories, FilterOptions, SubFilterObject } from './types';

export const commitAllStagedActiveValues = (
	prevState: UniformFilterObject,
): UniformFilterObject => {
	return Object.keys(prevState).reduce((acc, filterCategory) => {
		acc[filterCategory as FilterCategories] = {
			...prevState[filterCategory as FilterCategories],
			...Object.entries(prevState[filterCategory as FilterCategories]).reduce(
				(acc: SubFilterObject, [filterOptionName, filterOptionValue]) => {
					acc[filterOptionName] = {
						...filterOptionValue,
						committedActive: filterOptionValue.stagedActive,
					};
					return acc;
				},
				{},
			),
		};
		return acc;
	}, {} as UniformFilterObject);
};

export const setAllStagedActiveToFalse = (prevState: UniformFilterObject): UniformFilterObject => {
	return Object.keys(prevState).reduce((acc, filterCategory) => {
		acc[filterCategory as FilterCategories] = {
			...prevState[filterCategory as FilterCategories],
			...Object.entries(prevState[filterCategory as FilterCategories]).reduce(
				(acc: SubFilterObject, [filterOptionName, filterOptionValue]) => {
					acc[filterOptionName] = {
						...filterOptionValue,
						stagedActive: false,
					};
					return acc;
				},
				{},
			),
		};
		return acc;
	}, {} as UniformFilterObject);
};

export const resetAllStagedActiveToCommittedActiveValue = (
	prevState: UniformFilterObject,
): UniformFilterObject => {
	return Object.keys(prevState).reduce((acc, filterCategory) => {
		acc[filterCategory as FilterCategories] = {
			...prevState[filterCategory as FilterCategories],
			...Object.entries(prevState[filterCategory as FilterCategories]).reduce(
				(acc: SubFilterObject, [filterOptionName, filterOptionValue]) => {
					acc[filterOptionName] = {
						...filterOptionValue,
						stagedActive: filterOptionValue.committedActive,
					};
					return acc;
				},
				{},
			),
		};
		return acc;
	}, {} as UniformFilterObject);
};

export const getActiveFiltersByFilterType = (
	filter: FilterCategories | 'all',
	filterObject: UniformFilterObject,
): number => {
	if (filter === 'all') {
		return Object.values(filterObject).reduce(
			(acc: number, filterCategory: SubFilterObject) =>
				acc +
				Object.values(filterCategory).reduce(
					(subacc: number, filterOption: FilterOptions) =>
						filterOption.committedActive ? subacc + 1 : subacc,
					0,
				),
			0,
		);
	} else {
		return Object.values(filterObject[filter]).reduce(
			(acc: number, subFilter: FilterOptions) => (subFilter.committedActive ? acc + 1 : acc),
			0,
		);
	}
};
